import { TableHeader, TableRow, TableHead } from "@/components/ui/table";
import { Table } from "@tanstack/react-table";
import { cn } from "@/lib/utils";

interface SortableTableHeaderProps<TData> {
  table: Table<TData>;
}

export function SortableTableHeader<TData>({ table }: SortableTableHeaderProps<TData>) {
  //TODO: Maybe we should make the column headers unclickable while the data is loading?
  //What happens if the user clicks on a column header while the data is loading?
  return (
    <TableHeader className="table-header">
      <TableRow>
        {table.getFlatHeaders().map((header) => {
          const meta = header.column.columnDef.meta as { width?: string; headerClassName?: string } | undefined;
          return (
            <TableHead
              key={header.id}
              onClick={header.column.getToggleSortingHandler()}
              style={
                meta?.width
                  ? {
                      width: meta.width,
                      minWidth: meta.width,
                      maxWidth: meta.width,
                    }
                  : undefined
              }
              className={cn("cursor-pointer", header.column.getIsSorted() && "font-bold", meta?.headerClassName)}
            >
              {header.isPlaceholder
                ? null
                : typeof header.column.columnDef.header === "function"
                  ? header.column.columnDef.header(header.getContext())
                  : header.column.columnDef.header}
              {header.column.getIsSorted() === "asc" && " ↑"}
              {header.column.getIsSorted() === "desc" && " ↓"}
            </TableHead>
          );
        })}
      </TableRow>
    </TableHeader>
  );
}
